import { Navigate, useLocation } from "react-router-dom"
import { Box, CircularProgress } from "@mui/material"
import { useAuth } from "./AuthProvider"

const RequireAuthRoute = ({ children }) => {
    const { isAuthenticated, initialising } = useAuth()
    const location = useLocation()

    if (initialising) {
        return (
            <Box sx={{ minHeight: "100vh", display: "grid", placeItems: "center" }}>
                <CircularProgress color="secondary" />
            </Box>
        )
    }

    if (!isAuthenticated) {
        return <Navigate to="/admin/login" replace state={{ from: location }} />
    }

    return children
}

export default RequireAuthRoute
